import React from 'react';

import { Badge, Flex } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

import { ValueLabelResponse } from 'types';

interface TableCellBadgesProps {
  items?: ValueLabelResponse[];
}

export const TableCellBadges: React.FC<TableCellBadgesProps> = ({ items }) => {
  return (
    <Flex gridArea='team' flexDirection='column' alignItems='flex-start'>
      {items?.map((item: ValueLabelResponse) => (
        <Badge
          key={item.value}
          mb='.25rem'
          bg={COLOURS.blue[150]}
          color={COLOURS.black}
          sx={{
            '&:last-of-type': {
              mb: 0,
            },
          }}
        >
          {item.label}
        </Badge>
      ))}
    </Flex>
  );
};
